export interface ModalManager {
  categoryFilter: boolean;
  productFilter: boolean;
  bundlesFilter: boolean;
}

export const modalManager: ModalManager = {
  categoryFilter: false,
  productFilter: false,
  bundlesFilter: false,
};
